import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 使用 Element UI
Vue.use(ElementUI)

Vue.prototype.HOST = '/api';

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
